export const verify_wall_blocked_body = {
  body: "You are signed in, but your email is not verified yet. Check your inbox for a verification email. Some features may be limited until you verify.",
};
